.slot {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 0;
  font-weight: 400;
  width: 100%;
  height: 100%;
}

.free {
  background-color: var(--calendar-reservation-free-background-color);
  color: var(--common-gray-7);
}

.free:hover,
.free:focus {
  background-color: var(--calendar-reservation-free-background-color-hover);
}

.own {
  background-color: var(--calendar-reservation-own-background-color);
  color: var(--common-gray-2);
}

.own:hover,
.own:focus {
  background-color: var(--calendar-reservation-own-background-color-hover);
}

.disabled {
  background-color: var(--common-gray-2);
  color: var(--common-gray-6);
  font-weight: 100;
  cursor: not-allowed;
}

.selected {
  outline: 2px solid var(--brand-6);
  z-index: 10;
}

.singleWrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.singleBadgeWrapper {
  text-align: center;
}

.singleBadge {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background-color: var(--common-yellow-4);
  color: var(--common-gray-7);
  border-radius: 9999px;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
}

.detailsTime {
  font-weight: 400;
}

.detailsText {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  font-weight: 400;
}
